import { render, staticRenderFns } from "./CutThePrice.vue?vue&type=template&id=4b9f4cab&"
import script from "./CutThePrice.vue?vue&type=script&lang=js&"
export * from "./CutThePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports